// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import VueLocalStorage from 'vue-localstorage'
import VeeValidate from 'vee-validate'
import VueResource from 'vue-resource'
import VuejsDialog from 'vuejs-dialog'
import VCalendar from 'v-calendar'
import Paginate from 'vuejs-paginate';
import Notifications from 'vue-notification'
import 'v-calendar/lib/v-calendar.min.css'
import VueTagsInput from '@johmun/vue-tags-input';
import { MultiSelectPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns';
import VueClazyLoad from 'vue-clazy-load';



import './assets/css/main.css';
// import Loading from 'vue-loading-overlay';
// import 'vue-loading-overlay/dist/vue-loading.css';
import VueSimpleAlert from "vue-simple-alert";
Vue.config.silent = true; 
Vue.use(VueSimpleAlert);
import { CheckBox, ChangeEventArgs } from '@syncfusion/ej2-buttons';

// ===== CENTRALIZED AXIOS CONFIGURATION WITH ENCRYPTED USER ID =====
const axios = require('axios')

// Simple MD5 hash function (using existing hash logic pattern from the project)
const simpleHash = (str) => {
  let hash = 0
  if (str.length === 0) return hash.toString(36)
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash = hash & hash // Convert to 32bit integer
  }
  return Math.abs(hash).toString(36)
}

// Function to encrypt user ID using hashing
const encryptUserId = (userId) => {
  if (!userId) return ''
  try {
    // Create a unique hash using user ID and timestamp
    const timestamp = Date.now()
    const hashData = `${userId}:${timestamp}`
    const hash = simpleHash(hashData)
    
    // Combine hash with timestamp for server verification
    // Format: hash_timestamp
    return `${hash}_${timestamp}`
  } catch (error) {
    console.error('Error encrypting userId:', error)
    return ''
  }
}

// Request interceptor - adds x-access-token and x-encrypted-userid to all API calls
axios.interceptors.request.use(
  (config) => {
    const userData = localStorage.getItem('userData')
    if (userData) {
      try {
        const userInfo = JSON.parse(userData)
        
        // Add x-access-token if available and not already set
        if (userInfo[0] && userInfo[0].token && !config.headers['x-access-token']) {
          config.headers['x-access-token'] = userInfo[0].token
        }
        // const ENCRYPTION_KEY = 'FC-PLM-SECURE-KEY-2025-BUYER-PORTAL' 

        
        if (userInfo[0] && userInfo[0].user_id) {
          
          const saltedData = `${userInfo[0].user_id}`
          config.headers['x-encrypted-userid'] = saltedData
        }
        if(userInfo[0] && userInfo[0].brand_assign){
          const saltedData = `${userInfo[0].brand_assign}`
          config.headers['x-encrypted-brandid'] = saltedData
        }
        config.headers['X-Path'] = router.currentRoute.path;

      } catch (error) {
        console.error('Error processing userData:', error)
      }
    }
    
    // Set default headers if not already set
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    }
    if (!config.headers['Accept']) {
      config.headers['Accept'] = 'application/json'
    }
    
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor - handles 401 errors automatically
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn('Unauthorized - redirecting to login')
      localStorage.clear()
      if (window.location.pathname !== '/login' && window.location.pathname !== '/camsLogin') {
        // window.location.href = '/login'
        window.location.href = '/cams_login'
      }
    }
    return Promise.reject(error)
  }
)
// ===== END CENTRALIZED AXIOS CONFIGURATION =====

// todo
// cssVars()
Vue.use(MultiSelectPlugin);
Vue.use(VueLocalStorage)
Vue.use(BootstrapVue)
Vue.component('paginate', Paginate)
Vue.use(Notifications)
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields'
});
Vue.use(VueResource)
Vue.use(VuejsDialog)
Vue.use(VCalendar)
Vue.use(VueTagsInput);
Vue.use(MultiSelectPlugin);
MultiSelect.Inject(CheckBoxSelection);
Vue.use(VueClazyLoad);




/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})
